import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

/**
 * Standard admin modal: title (fixed) → scrollable body (thin dark .vr-scroll-y) → actions (fixed).
 */
export default function AdminModal({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth = 'sm',
  disableClose = false
}) {
  return (
    <Dialog
      open={open}
      onClose={disableClose ? undefined : onClose}
      fullWidth
      maxWidth={maxWidth}
      scroll="paper"
      BackdropProps={{ sx: { backgroundColor: 'rgba(0, 0, 0, 0.65)' } }}
      PaperProps={{
        sx: {
          display: 'flex',
          flexDirection: 'column',
          maxHeight: 'min(90vh, 640px)',
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          backgroundImage: 'none'
        }
      }}
    >
      <DialogTitle
        component="div"
        sx={{
          flexShrink: 0,
          py: 2,
          px: 3,
          fontWeight: 600,
          fontSize: '1.05rem',
          lineHeight: 1.3,
          borderBottom: '1px solid',
          borderColor: 'divider'
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent
        className="vr-scroll-y"
        sx={(theme) => ({
          flex: '1 1 auto',
          minHeight: 0,
          overflowY: 'auto',
          px: 3,
          py: 2,
          // MUI ставит paddingTop: 0 сразу под заголовком — оставляем явный отступ, чтобы контент был под блоком title
          '.MuiDialogTitle-root + &': {
            paddingTop: theme.spacing(2)
          },
          bgcolor: 'rgba(0, 0, 0, 0.22)'
        })}
      >
        {children}
      </DialogContent>
      <DialogActions
        sx={{
          flexShrink: 0,
          px: 3,
          py: 2,
          gap: 1,
          borderTop: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper'
        }}
      >
        {actions}
      </DialogActions>
    </Dialog>
  );
}
